// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/DirectionSelector/DirectionSelector.css */

.direction-selector {
  display: flex;
  gap: 0;
  border-radius: var(--radius-full);
  overflow: hidden;
  border: 2px solid var(--color-border);
  background-color: var(--color-card-white);
}

.direction-selector__option {
  flex: 1 1;
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all var(--transition-fast);
  text-align: center;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
}

.direction-selector__option--active {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
}

.direction-selector__option:not(.direction-selector__option--active):hover {
  background-color: var(--color-progress-bg);
}`, "",{"version":3,"sources":["webpack://./src/components/DirectionSelector/DirectionSelector.css"],"names":[],"mappings":"AAAA,gHAAgH;;AAEhH;EACE,aAAa;EACb,MAAM;EACN,iCAAiC;EACjC,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,wCAAwC;EACxC,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/DirectionSelector/DirectionSelector.css */\n\n.direction-selector {\n  display: flex;\n  gap: 0;\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  background-color: var(--color-card-white);\n}\n\n.direction-selector__option {\n  flex: 1;\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-align: center;\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.direction-selector__option--active {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n}\n\n.direction-selector__option:not(.direction-selector__option--active):hover {\n  background-color: var(--color-progress-bg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
